module.exports = __webpack_public_path__ + "img/16.14ccc3dc.webp";